/**

 *
 * Partner UI
 *
 * Logic to handle the UI functionality for the partners page
 */

const $         = require( 'jQuery' );
const _model    = require( './utilities/_model.js' );
const _LStorage = require( './utilities/_LStorage' );
const _Forms    = require( './utilities/_form-controller' );
const { Foundation, ITBL, mixitup, TimelineMax } = window;



var PartnerUI = function(el){
    //setup some variables
    this.$el            = $(el);
    this.$stickySidebar = this.$el.find( '#sort-sidebar' );
    this.stickyOffset   = 0;

    //mixitup search input
    this.$mixSearch            = this.$el.find( '#itbl-c-partners__search' );
    this.$mixSearch__input   = this.$mixSearch.find( '.itbl-b-searchbox__input' );
    this.$mixSearch__clear   = this.$mixSearch.find( '.itbl-b-searchbox__clear' );
    this.$mixSearch__submit  = this.$mixSearch.find( '.itbl-b-searchbox__submit' );


    this.mixitup = null;

    this.init();
};

PartnerUI.prototype.init = function(){

    //instantiates the mixitup class
    this.mixitup = mixitup( this.$el,
        {
            selectors: {
                control: '[data-mixitup-control]',
                target: '.mix'
            },
            controls: {
                toggleDefault: 'all'
            },
            animation: {
                duration: 300,
                easing: 'cubic-bezier(0.86, 0, 0.07, 1)'
            },
            callbacks: {
                onMixStart: (  state )=> {
                },
                onMixEnd: ( state )=> {

                    //smooth scroll to the stop of the list
                    Foundation.SmoothScroll.scrollToLoc('#sort-items', {
                        threshold: 50,
                        offset: 100,
                        animationDuration: 200
                    }, ()=>{
                    });

                },

            }
        }
    );

    //events here
    this.$mixSearch.on( 'submit', this.event__blogSearch.bind(this) );

    this.$mixSearch__clear.on( 'click', this.event__clearMixInput.bind( this ) );


    document.addEventListener('itbl.menuScroll', this.event__handleStickyTop.bind(this ));
};

PartnerUI.prototype.event__blogSearch = function( event ){
    event.preventDefault();

    var that = this;

    let inputText,
        $matching = $();

    inputText = $( this.$mixSearch__input ).val().toLowerCase();


    // Check to see if input field is empty
    if ((inputText.length) > 0) {
        $('.mix'  ).each(function() {
            var $this = $(this);


            // add item to be filtered out if input text matches items inside the title
            if($this[0].textContent.toLowerCase().match(inputText)) {
                $matching = $matching.add($this);
            }
            else {
                // removes any previously matched item
                $matching = $matching.not($this);
            }
        });

        this.mixitup.filter( $matching );
    }

    else {
        // resets the filter to show all item if input is empty
        that.mixitup.filter( 'all' );
    }


};

PartnerUI.prototype.event__clearMixInput = function(event){

    this.mixitup.filter( 'all' );

};

PartnerUI.prototype.event__handleStickyTop = function(event){

    try{
        let detail = event.detail.topNavEl;
        let topNavHeight = detail.outerHeight();

        if( topNavHeight !== this.stickyOffset ){

            this.$stickySidebar.css('top', topNavHeight+32 );

            this.stickyOffset = topNavHeight;

        }

    }catch (e) {

        this.$stickySidebar.css('top', 83+32 );

    }


};



/**
 *
 * Partner Interest Form UI
 *
 * Creating a separate class for the partner interest form because it does different stuff
 */

var InterestFormUI = function(el){

    this.$el        = $(el);
    this.$revealWrapper = this.$el.find('.itbl-b-reveal');
    this.$form      = this.$el.find( '.itbl-b-form' );
    this.$success   = this.$el.find( '.itbl-b-reveal__success' );
    this.$confirmationSvg  = this.$el.find( '.itbl-b-confirmation__svg' );
    this.$start    = this.$el.find( '.itbl-b-reveal__start' );

    this.FormInstance       = new Foundation.Abide( this.$form );


    //get all visible form input fields as array
    this.$visibleInputs     = this.$form.find( ':input:not([type="hidden"], [type=submit] )' ).map( (i, el ) => el.getAttribute( 'name') ).get();

    //get the user email from localstorage
    this.userEmail      = _LStorage.decrypt__get( 'iterable/encrypted/Email' );
    this.userFirstName  = _LStorage.decrypt__get( 'iterable/encrypted/FirstName' );
    this.userLastName   = _LStorage.decrypt__get( 'iterable/encrypted/LastName' );
    this.PII            = _Forms.helper__getEncryptedData();


    //start building obj for API calls
    //all actions will use this obj, the models for handling the requests will take the fields they need
    this.APIState     = Object.assign(
        {},
        {
            wp_email_to         : (this.$start[0].getAttribute( 'data-send-to' ) ) ? this.$start[0].getAttribute( 'data-send-to' ) : 'forms@iterable.com',
            wp_email_subject    : 'Partner Interest from Submission',
            wp_email_message    : null, //we gotta build this message body

        }

    );


    this.init();
};

InterestFormUI.prototype.init = function(){

    //events
    this.$form
        .on( 'submit', _Forms.event__PreventDefault.bind(this) )
        .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault.bind(this))
        .on( 'formvalid.zf.abide', this.event__validFrom.bind(this) );

};

InterestFormUI.prototype.event__validFrom = function( event, target ){

    var that = this;

    //disable normal submit event
    event.preventDefault();

    this.$start.addClass( 'itbl-u-faded' );

    //serialize this data into name/value
    _Forms.helper__addFormInputsToState( this.$form, this.APIState );

    _Forms.helper__setAllEncryptedVals( this.$visibleInputs, this.APIState );


    //7/15/2020 - Updated the marketo method to use manual POST
    _Forms.marketo__submit(this.APIState, undefined, undefined, this.$form)
        .catch( e =>{
            console.log( e );
        } )
        .finally( ()=>{

            this.view__showSuccess();
        });

    //just to be sure
    return false;
};

InterestFormUI.prototype.view__showSuccess = function(){

    var success = new TimelineMax();

    success
        //dim out the current form
        .to(this.$start, .5, {opacity:0})
        //set the height of the parent container
        .to(this.$revealWrapper, .3, {height: this.$success.outerHeight()})
        .set( this.$start, {display: 'none' } )
        //add the success element back to the DOM flow
        .set( this.$success, {position: 'initial' } )
        //add the classess
        .set( this.$success, {className:"+=animated"} )
        .set( this.$success, {className: "+=bounceInDown"})
        .set( this.$confirmationSvg, {className:"-=itbl-e-hide"}, "+=1")
        .set( this.$confirmationSvg, {className:"+=animated"} )
        .set( this.$confirmationSvg, {className: "+=heartBeat"} )
        //clear the height property cuz we don't need it anymore
        .set( this.$revealWrapper, {clearProps: 'height'} );

};

InterestFormUI.prototype.helper__populateInputs = function(){

    if( ! this.userEmail || !this.PII || ! this.$visibleInputs ){
        console.log( 'could not populate fields', this.userEmail, this.PII, this.$visibleInputs );
        return false;
    }

    try {

        //set the encypted fields in the form
        $.each(this.$visibleInputs, (i, v)=> {

            let input = $(`#${v}`);

            if (input.is('select')) {

                input.val(this.PII[v]).attr('selected', 'selected');

            } else {

                input.val(( ! _model.empty(this.PII[v]) ) ? `${this.PII[v]}` : '');
            }
        });
    }
    catch (e) {
        console.log( 'Something weird happened with setting the vals ', e );
    }


};


$(document).ready(function(){

    //call the partner interest form logic
    $('#form-partner__id, #form-demo__id').each(function(){
        new InterestFormUI(this);
    });

    //call the archive page partner logic
    $('.itbl-c-partners').each(function(){
        new PartnerUI(this);
    });

});








